import React, { useEffect, useState } from "react";
import { CardContent, Typography, Stack, Box, Avatar } from "@mui/material";
import EventBusy from "../../assets/images/event_busy.png";
import { StyledCard } from "../../assets/styled-components/StyledCard";
import { useNavigate } from "react-router-dom";
import { BemsGraph, FemsGraph } from "../../utility/apiURLS";
import { getAuthToken, getFacilityId } from "../../utility/tokenUtility";
import axios from "axios";

function NewWorkRequest({ response }) {
  const navigate = useNavigate()
  const [count, setCount] = useState(0);
  const facilityId = getFacilityId("");
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;

  const fetchUserDepartments = async (selectedService) => {
    try {
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const departmentid = localStorage.getItem("roleName") === "DeptUser" ? 1 : 0;
      const userid = localStorage.getItem("UserId");
      const [responseFEMS, responseBEMS] = await Promise.all([
        axios.get(
          `${FemsGraph}/api/GraphfemDepartmentrequest/Getfemsworkrequestlist/${facilityId}/${currentYear}/${currentMonth}/0/${userid}/${token}`,
          config
        ),
        axios.get(
          `${BemsGraph}/api/GraphbemDepartmentrequest/Getbemsworkrequestlist/${facilityId}/${currentYear}/${currentMonth}/0/${userid}/${token}`,
          config
        ),
      ]);

      setCount(
        responseFEMS.data.items.filter((data) => data?.status === 'Open' && data?.workorderNo ==='').length +
        responseBEMS.data.items.filter((data) => data?.status === 'Open' && data?.workorderNo ==='').length)

    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  const handleNavigate = () => {
    navigate("/workorder", {
      state: {
        tab: 3,
      },
    });
  }

  useEffect(() => {
    fetchUserDepartments();
  }, []);
  return (
    <>
      <StyledCard sx={{ cursor: "pointer" }}>
        <CardContent onClick={handleNavigate}>
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Box>
              <Typography mb={1.5} variant="h5" color={"text.primary"}>
                New Work Request
              </Typography>
              <Typography m={0} variant="h1" color={"#435954"}>
                {count}
              </Typography>
            </Box>
            <Box bgcolor={"#435954"} p={1} borderRadius={50}>
              <Avatar
                alt="Remy Sharp"
                src={EventBusy}
                sx={{ width: 24, height: 24 }}
              ></Avatar>
            </Box>
          </Stack>
        </CardContent>
      </StyledCard>
    </>
  );
}

export default NewWorkRequest;
